import { useCallback, useEffect, useRef } from 'react'
import { useIsomorphicEffect } from './useIsomorphicEffect'
import { useRouter } from './useRouter'

function useFullSizeModalRouteUpdater(modalCode: string, onDismiss: () => void): () => void {
  const { push, query, pathname, back } = useRouter()

  const isHistoryPushed = useRef(false)
  const modalCodeRef = useRef(`${modalCode}--${Date.now() % 10000}`)
  const isClosing = useRef(false)

  useEffect(() => {
    const modals = query.modals?.toString().split(',') || []
    const isQueryIncludeModalCode = modals.includes(modalCodeRef.current)

    if (isQueryIncludeModalCode && !isHistoryPushed.current) {
      isHistoryPushed.current = true
    }

    if (!isQueryIncludeModalCode && isHistoryPushed.current && !isClosing.current) {
      isClosing.current = true
      onDismiss()
    }
  }, [query])

  useIsomorphicEffect(() => {
    const modals = query.modals?.toString().split(',') || []
    const isQueryIncludeModalCode = modals.includes(modalCodeRef.current)
    if (!isQueryIncludeModalCode) {
      push(
        {
          pathname,
          query: {
            ...query,
            modals: [...modals, modalCodeRef.current].join(','),
          },
        },
        undefined,
        { shallow: true },
      )
    }
  }, [])

  return useCallback(() => {
    if (isClosing.current) return
    if (isHistoryPushed.current) {
      back()
    } else {
      onDismiss()
    }
  }, [back])
}

export default useFullSizeModalRouteUpdater
